import { Box, Image, Text, Link, RadioGroup, Radio } from "@chakra-ui/react";
import React, { useState, useEffect,useRef } from "react";
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { FetchDoctorClinics, FetchDoctorRoles, getProfile} from "../../middleware/services/profile";
import PrimaryButton from "../primary-button";
import DynamicModal from "../dynamic-modal";
import { saveIsDoctor, saveLoginDetails } from "../../auth";
import useLoader from "../loader/loaderstates";
import Loader from "../loader/loader";
import { getLoginID } from "../../auth";
import Toaster from "../toaster";

const MobileNavbar = () => {
  const [activeLink, setActiveLink] = useState(null);
  const [profilePictureUrl, setProfilePictureUrl] = useState('');
  const [imagePath, setImagePath] = useState('');
  const [DoctorAvailability, setDoctorAvailability] = useState("")
  const { showSuccessToast, showErrorToast } = Toaster();
  const { isLoading, showLoader, dismissLoader } = useLoader();

  var navigate = useNavigate();
  const location = useLocation();
  const [disablePages, setDisablePages] = useState("");
    const [defaultCheckedState, setDefaultCheckedState] = useState(null)
    const [IsSuperUser, setIsSuperUser] = useState(null)
    const [IsglobalAdmin, setIsglobalAdmin] = useState(null)
    let  issuperuser = (localStorage.getItem("issuperuser"));
    let isglobaladmin = localStorage.getItem("issuperuser");
    const selectBranch = useRef()
    const [userTypeId, setUserTypeId] = useState(null)
    const branchSelection = JSON.parse(localStorage.getItem('branchSelection'));
   useEffect(() => {
    //getDoctorProfile();
    let disablePages = JSON.parse(localStorage.getItem("pagesAccess")); 
    if(branchSelection){
      FetchClinicsList()
      selectBranch.current.openModal()
    }
    setDisablePages(disablePages)
    // let actionAccessLocal = JSON.parse(localStorage.getItem("actionAccess"));
    // setActionAccess(actionAccessLocal)
    let doctorid = getLoginID();
    const branchIdFromLocal = localStorage.getItem("branchid");
    if (branchIdFromLocal) {

      setDefaultCheckedState(branchIdFromLocal)
    } else {

      setDefaultCheckedState(doctorid)
    }
  }, [branchSelection]);
  const [clinicList, setClinicList] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState('');
  const [clinicData, setClinicData] = useState([]);
  const FetchClinicsList = async ()=>{
    try {
      var result = await FetchDoctorClinics({
       "type":"getbranch",
       "doctorid": getLoginID()
      });
      // console.log('FetchSpecialities: ', result)
      if (result != null) {
        // const clinicsResult = result.map((item) => item.clinicname)
        setClinicList(result)
        // console.log(result, 'clinicList')
        setClinicData(result)
        // setClinicList(result)
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile")
    }
  }

  const handleClose = () => { 
    const {branchid, hospitalid} = clinicData && clinicData[0]
    localStorage.setItem("branchid",branchid)
    localStorage.setItem("hospitalid",hospitalid)
    localStorage.removeItem('branchSelection')
    
    selectBranch.current.closeModal();
    window.location.reload(); 
  };

  const handleBranchSelection = async ()=> {
    if(!selectedBranch){
      showErrorToast("Please select a branch")
      return
    } else {
      showLoader();
      let branchData = clinicData.find(item => item.branchid == selectedBranch)
      const {branchid, hospitalid, roleid} = branchData
      // let hospitalid = clinicData.find(item => item.clinicname == selectedBranch).hospitalid
      // let roleid = clinicData.find(item => item.clinicname == selectedBranch).roleid
      try {
        var response = await FetchDoctorRoles({
         "branchid":branchid,
         "hospitalid":hospitalid,
         "roleid": roleid
        });
        if (response != null) {
        //  console.log(response, 'result');
         if (response.data.resultplan && response.data.resultplan.length > 0) {
  const subscription = response.data.resultplan[0];
  localStorage.setItem("subscriptionName", subscription.subscriptionname);
  localStorage.setItem("subscriptionEndDate", subscription.subscriptionenddate);
  
  // localStorage.setItem("subscriptionPlanId", subscription.subscriptionplanid);
  // localStorage.setItem("subscriptionPrice", subscription.subscriptionprice);
  // localStorage.setItem("subscriptionDuration", subscription.duration);
}
         setUserTypeId(response?.data?.usertypeid)
        //  localStorage.setItem("saveDischarge", response?.data?.dischargenote);    
         localStorage.setItem("usertypeid" ,response?.data?.usertypeid);
         localStorage.setItem("rolename" ,response?.data?.rolename);
        //  localStorage.setItem("countrycode" ,response?.data?.countryid);
        //  localStorage.setItem("countryid" ,response?.data?.countrycode);
         const allPagesShowHideMainFunc = ()=>{
          if(!response?.data?.disablehome){
            navigate("/home");
          }else if(!response?.data?.disablevisits){
            navigate("/visits");
          }else if(!response?.data?.disablemessages){
            navigate("/messages");
          }else if(!response?.data?.disablepatients){
            navigate("/patients");
          }else if(!response?.data?.disableprescriptions){
            navigate("/prescriptions");
          }else if(!response?.data?.disablemedicines){
            navigate("/medicines");
          }else if(!response?.data?.disablereports){
            navigate("/reports");
          }else if(!response?.data?.disablenotifications){
            navigate("/notifications");
          }else if(!response?.data?.disableroles){
            navigate("/doctorprofile");
          }else if(!response?.data?.disableusers){
            navigate("/doctorprofile");
          }else if(!response?.data?.disableinventory){
            navigate("/doctorprofile");
          }else if(!response?.data?.disablefinance){
            navigate("/doctorprofile");
          }else if(!response?.data?.disableinvoices){
            navigate("/doctorprofile");
          }else{
            navigate("/doctorprofile");
          }
         }
          let setInlocal = () =>{
            let pagesAccessObject = {};

            if (response && response.data) {
              // Loop through the keys in the response.data object
              Object.keys(response.data).forEach(key => {
                if (key.startsWith('disable')) {
                  // Add each disable key to pagesAccessObject
                  pagesAccessObject[key] = response.data[key];
                }
              });
            }
          
            localStorage.setItem("pagesAccess" ,JSON.stringify(pagesAccessObject));
            localStorage.setItem("actionAccess" , JSON.stringify(response.data.screens));
          }
          allPagesShowHideMainFunc();
          setInlocal();
        }
        if (response.data.isdoctor) {
          saveIsDoctor(response.data.isdoctor);
         }
        if (response?.data) {
            saveLoginDetails(response?.data);
        }
        localStorage.setItem("isglobaladmin", response.data.isglobaladmin);
        localStorage.setItem("issuperuser", response.data.issuperuser);
        localStorage.setItem("branchid",branchid)
        localStorage.setItem("hospitalid",hospitalid)
        localStorage.setItem("roleid",roleid)
        localStorage.removeItem('branchSelection')
        setIsSuperUser(response.data.issuperuser);
        setIsglobalAdmin(response.data.isglobaladmin);
        window.location.reload(); 
      } catch (error) {
        console.log(error, "Something went wrong in doctor profile")
      }

    }
  }

  // Handle functions
  const handleLinkClick = (section) => {
    setActiveLink(section);
  };  


  // useEffect(() => {
  //   getDoctorProfile();
  // }, []);

  var inputForGet = {
  }
  const getDoctorProfile = async () => {

    try {
      var result = await getProfile(inputForGet);
      if (result && result.ProfileOutput) {
        setDoctorAvailability(result.ProfileOutput)
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile")
    }
  }
  const navigatetohome = ()=>{
    navigate("/home")
  }

  const linkStyle = {
    textDecoration: 'none',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    padding: '0 5px',
    position: 'relative',
    width: '100%',
  };

  const activeLinkStyle = {
    ...linkStyle,
    _after: {
      content: '""',
      position: 'absolute',
      right: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      width: '5px',
      height: '100%',
      backgroundColor: 'green',
      borderRadius: '5px 0 0 5px',
    },
  };
  return (
    <>
      <Box pos="relative">
        <Box
          as="nav"
          pos="fixed"
          zIndex="999"
          alignItems="center"
          justifyContent="space-between"
          p="0.5rem"
          bottom="0"
          left="0"
          right="0"
          borderTop="1px solid #E6E7E9"
          bg="#0B0B0D"
          spacing={4}
          display='flex'
        >
          <Link
            display="flex"
            flexDir="column"
            alignItems="center"
            justifyContent="center"
            p="0.5rem"
            fontSize="0.75rem"
            fontWeight="600"
            href="/home"
            color={activeLink === "home" ? "#061027" : "#6A707D"}
            onClick={() => handleLinkClick("home")}
          >
            {/* <Image
              src="/assets/svgs/mobile-home-active.svg"
              w="1.125rem"
              h="1.25rem"
              className={activeLink == "home" ? "lightBtn" : "darkBtn"}
            /> */}
            <Image w="1rem" src={location.pathname == "/home" ? '/assets/svgs/home-white.svg' : '/assets/svgs/home.svg'}/>
            <Text letterSpacing="-0.03em" fontSize="0.625rem">Dashboard</Text>
          </Link>
          <Link
            display="flex"
            flexDir="column"
            alignItems="center"
            justifyContent="center"
            p="0.5rem"
            fontSize="0.75rem"
            fontWeight="600"
            href="/visits"
            color={activeLink === "visits" ? "#061027" : "#6A707D"}
            onClick={() => handleLinkClick("visits")}
          >
            {/* <Image
              src="/assets/svgs/mobile-appointments-inactive.svg"
              w="1.125rem"
              h="1.25rem"
              className={activeLink == "appointments" ? "lightBtn" : "darkBtn"}
            /> */}
            <Image w="1rem" src={location.pathname == "/visits" ? '/assets/svgs/visits-white.svg' : '/assets/svgs/calendar-visits.svg'}/>
            <Text letterSpacing="-0.03em" fontSize="0.625rem">Visits</Text>
          </Link>
          <Link
            display="flex"
            flexDir="column"
            alignItems="center"
            justifyContent="center"
            p="0.5rem"
            fontSize="0.75rem"
            fontWeight="600"
            href="/messages"
            color={activeLink === "messages" ? "#061027" : "#6A707D"}
            onClick={() => handleLinkClick("messages")}
          >
            <Image w="1rem" src={location.pathname == "/messages" ? '/assets/svgs/messages-white.svg' : '/assets/svgs/messages-filled.svg'}/>
            <Text letterSpacing="-0.03em" fontSize="0.625rem">Messages</Text>
          </Link>
          <Link
            display="flex"
            flexDir="column"
            alignItems="center"
            justifyContent="center"
            p="0.5rem"
            fontSize="0.75rem"
            fontWeight="600"
            href="/prescriptions"
            color={activeLink === "prescriptions" ? "#061027" : "#6A707D"}
            onClick={() => handleLinkClick("prescriptions")}
          >
            <Image w="1rem" src="/assets/svgs/prescriptions.svg" 
                filter={
                  location.pathname == "/prescriptions"
                    ? "brightness(0) saturate(100%) invert(99%) sepia(1%) saturate(7364%) hue-rotate(186deg) brightness(111%) contrast(97%)"
                    : "brightness(0) saturate(100%) invert(43%) sepia(21%) saturate(242%) hue-rotate(183deg) brightness(95%) contrast(88%)"
                }
            />
            <Text letterSpacing="-0.03em" fontSize="0.625rem">Orders</Text>
          </Link>
          <Link
            display="flex"
            flexDir="column"
            alignItems="center"
            justifyContent="center"
            p="0.5rem"
            fontSize="0.75rem"
            fontWeight="600"
            href="/medicines"
            color={activeLink === "medicines" ? "#061027" : "#6A707D"}
            onClick={() => handleLinkClick("medicines")}
          >
            <Image w="0.875rem" src="/assets/svgs/medication.svg"
                filter={
                  location.pathname == "/medicines"
                    ? "brightness(0) saturate(100%) invert(99%) sepia(1%) saturate(7364%) hue-rotate(186deg) brightness(111%) contrast(97%)"
                    : ""
                }
            />
            <Text letterSpacing="-0.03em" fontSize="0.625rem">Medicines</Text>
          </Link>
          <Link
            display="flex"
            flexDir="column"
            alignItems="center"
            justifyContent="center"
            p="0.5rem"
            fontSize="0.75rem"
            fontWeight="600"
            href="/reports"
            color={activeLink === "reports" ? "#061027" : "#6A707D"}
            onClick={() => handleLinkClick("reports")}
          >
            {/* <Image
              src="/assets/svgs/mobile-chat-inactive.svg"
              w="1.125rem"
              h="1.25rem"
              className={activeLink == "chat" ? "lightBtn" : "darkBtn"}
            /> */}
            <Image w="1rem" src={location.pathname == "/reports" ? '/assets/svgs/report-white.svg' : '/assets/svgs/reports-filled.svg'}/>
            <Text letterSpacing="-0.03em" fontSize="0.625rem">Reports</Text>
          </Link>
          <Link
            display="flex"
            flexDir="column"
            alignItems="center"
            justifyContent="center"
            p="0.5rem"
            fontSize="0.75rem"
            fontWeight="600"
            href="/profile"
            filter={location.pathname == "/profile" ? "brightness(0) saturate(100%) invert(99%) sepia(1%) saturate(7364%) hue-rotate(186deg) brightness(111%) contrast(97%)" : " "}
            color={activeLink === "more" ? "#061027" : "#6A707D"}
            onClick={() => handleLinkClick("more")}
          >
            {/* <Image
              src="/assets/svgs/mobile-profile-inactive.svg"
              w="1.125rem"
              h="1.25rem"
              className={activeLink == "profile" ? "lightBtn" : "darkBtn"}
            /> */}
            <Image w="1.125rem" src='/assets/svgs/more-gray.svg'/>
            <Text letterSpacing="-0.03em" fontSize="0.625rem">More</Text>
          </Link>
        </Box>
      </Box>
      <DynamicModal
        ref={selectBranch}
        modalHeader="Select Branch"
        modalBodyStyle={{p:'0.75rem 1rem'}}
        customCloseHandler={handleClose}
        modalBody={
          <RadioGroup display='flex' flexDir='column' value={selectedBranch} onChange={(e)=> setSelectedBranch(e)}>
            {clinicList?.length > 0 && clinicList.map((item, index) => (
              <Box 
                border={selectedBranch == item.branchid ? '2px solid #14C585' : 'inherit'}
                borderRadius={selectedBranch == item.branchid ? '10px' : '0'}
                p='10px 8px'
                pl='0'
              >
                <Radio 
                  display='flex' 
                  key={index} w='100%' 
                  value={item.branchid.toString()} 
                  justifyContent='space-between' 
                  flexDir='row-reverse' 
                  colorScheme="green"
                  m='0'
                >
                  <Text>{item.clinicname}</Text>
                </Radio>
              </Box>
            ))}
          </RadioGroup>
        }
        // hasFooter={false}
        modalFooterBtn={
          <PrimaryButton buttonText="Submit" onClick={handleBranchSelection} />
        }
      />
    </>
    
  );
};

export default MobileNavbar;
